import React, { useEffect, useState } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { DefaultCard } from "../../assets/styled-components/card";
import VerticalLinearStepper from "../commoncomponents/stepper";
import PageTitle from '../commoncomponents/PageTitle';
import BasicDetails from './BasicDetails';
import Assessments from './Assessments';
import PartReplacement from './PartReplacement';
import CompletionInfo from './CompletionInfo';
import CostInfo from './CostInfo';
import SummaryAuthorization from './SummaryAuthorization';
import Attachments from "./Attachments";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { useLocation } from "react-router-dom";
import { error } from "pdf-lib";
import { decryptDataForHyperlink } from "../../redux/actions/workOrderActionTypes";


const WorkOrderStepper = () => {
    const { mandatoryFieldsBasicDetails, completionInfoMandatoryFields, assessmentsMandatoryFields } = useSelector((state) => state.workOrdermandatoryFields);
    const getStepper = useSelector((state) => state?.checkParts);
    const getStatus = useSelector((state) => state?.workOrderStatus);
    const decryptData = useSelector((state)=>state?.hyperLinkData)
    const dispatch = useDispatch();
    const [mandatoryBasicDetails, setMandatoryBasicDetails] = useState(mandatoryFieldsBasicDetails);
    const [mandatoryCompletionInfo, setMandatoryCompletionInfo] = useState(completionInfoMandatoryFields);
    const [mandatoryAssessments, setMandatoryAssessments] = useState(assessmentsMandatoryFields);
    // const [decryptData,setDecryptData] = useState({});
    const location = useLocation();
    
     // Function to import the key from a Base64 string
async function importKey(base64Key) {
    const rawKey = base64ToArrayBuffer(base64Key);
    return await crypto.subtle.importKey('raw', rawKey, 'AES-GCM', true, ['decrypt']);
}

// Function to convert Base64 string to ArrayBuffer
function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

// Function to decrypt data using AES-GCM
async function decryptDataKey(key, encryptedData, iv) {
    const decrypted = await crypto.subtle.decrypt(
        {
            name: "AES-GCM",
            iv: iv,
        },
        key,
        encryptedData
    );

    const decoder = new TextDecoder();
    return JSON.parse(decoder.decode(decrypted));
}

// Retrieve the encrypted state, IV, and key from the URL
const queryParams = new URLSearchParams(location?.search);
const encryptedStateString = queryParams?.get("state");
const ivString = queryParams?.get("iv");
const keyString = queryParams?.get("key");

const getDecryptData = () =>{
    try {
        if (encryptedStateString && ivString && keyString) {
            // Convert the Base64 encoded data, IV, and key back to ArrayBuffer
            const encryptedData = base64ToArrayBuffer(decodeURIComponent(encryptedStateString));
            const iv = base64ToArrayBuffer(decodeURIComponent(ivString));
        
            // Import the encryption key
            importKey(decodeURIComponent(keyString)).then((key) => {
                // Decrypt the data
                decryptDataKey(key, encryptedData, iv).then((decryptedData) => {
                    dispatch(decryptDataForHyperlink("DECRYPT_DATA_REDUCERS_HYPERLINK",decryptedData))
                }).catch((error) => {
                    console.log("Decryption failed:", error);
                });
            });
        } 
    } catch (error) {
        console.log("Decryption failed:", error)
    }
}

    useEffect(()=>{
        getDecryptData()
    },[])


    const title = location?.state?.title || decryptData?.title || "";
    const [authorizeTick, setAuthourizeTick] = useState(0);

    useEffect(() => {
        if (mandatoryFieldsBasicDetails) {
            setMandatoryBasicDetails(mandatoryFieldsBasicDetails)
        }
        if (assessmentsMandatoryFields) {
            setMandatoryAssessments(mandatoryAssessments);
        }
        if (completionInfoMandatoryFields) {
            setMandatoryCompletionInfo(mandatoryCompletionInfo);
        }
    }, [mandatoryFieldsBasicDetails, mandatoryCompletionInfo, mandatoryAssessments])

    const [page, setPage] = useState("Basic Details");
    const stepsForAsset = getStepper;
    const mapPercentageToLabelId = (percentage) => {
        if (percentage === 100) return 7;
        if (percentage === 92) return 6;
        if (percentage === 88) return 5;
        if (percentage === 68) return 4;
        if (percentage === 48) return 3;
        if (percentage === 32) return 2;
        if (percentage === 16) return 1;
        return 0; // Default for anything else
    };

    const updatedSteps = stepsForAsset.map((step) => ({
        ...step,
        value: getStatus?.percentage || 0,  // Update the value from API response
        labelId: mapPercentageToLabelId(getStatus?.percentage || "") + (authorizeTick || 0), // Map percentage to correct labelId
    }));


    const hasPartReplacement = updatedSteps.some(step => step.key === "Part Replacement");

    const buttonAttributes = [
        {
            currentPageName: "Basic Details",
            setPage: setPage,
            cancelButtonName: "Close",
            continueButtonName: "Continue to Assessments",
            backButtonName: "",
            backButton: false,
            nextPageName: "Assessments",
            previousPageName: "",
            mainHeader: "Basic Details",
            requiredButton: true,
            subHeader: "",
            secondSubHeaderAndDate: false,
            cancelWO: "Cancel WO"
        },
        {
            currentPageName: "Assessments",
            setPage: setPage,
            cancelButtonName: "Cancel",
            continueButtonName: "Continue to Attachments",
            backButtonName: "Back to Basic Details",
            backButton: true,
            nextPageName: "Attachments",
            previousPageName: "Basic Details",
            requiredButton: true,
            mainHeader: "Assessments",
            subHeader: "",
            secondSubHeaderAndDate: false,
        },
        // {
        //     currentPageName: "Assessments",
        //     setPage: setPage,
        //     cancelButtonName: "Cancel",
        //     continueButtonName: hasPartReplacement ? "Continue to Part Replacement" : "Continue to Completion Info",
        //     backButtonName: "Back to Basic Details",
        //     backButton: true,
        //     nextPageName: hasPartReplacement ? "Part Replacement" : "Completion Info",
        //     previousPageName: "Basic Details",
        //     requiredButton: true,
        //     mainHeader: "Assessments",
        //     subHeader: "",
        //     secondSubHeaderAndDate: false,
        // },
        {
            currentPageName: "Attachments",
            setPage: setPage,
            cancelButtonName: "Cancel",
            continueButtonName: hasPartReplacement ? "Continue to Part Replacement" : "Continue to Completion Info",
            backButtonName: "Back to Assessments",
            backButton: true,
            nextPageName: hasPartReplacement ? "Part Replacement" : "Completion Info",
            previousPageName: "Assessments",
            requiredButton: true,
            mainHeader: "Attachments",
            subHeader: "",
            secondSubHeaderAndDate: false,
        },
        // {
        //     currentPageName: "Attachments",
        //     setPage: setPage,
        //     cancelButtonName: "Cancel",
        //     continueButtonName: "Continue to Authorization",
        //     backButtonName: "Back to Cost Info",
        //     backButton: true,
        //     nextPageName: "Authorization & Summary",
        //     previousPageName: "Back to Assessments",
        //     requiredButton: true,
        //     mainHeader: "Attachments",
        //     subHeader: "",
        //     secondSubHeaderAndDate: false,
        // },
        hasPartReplacement && {
            currentPageName: "Part Replacement",
            setPage: setPage,
            cancelButtonName: "Cancel",
            continueButtonName: "Continue to Completion Info",
            backButtonName: "Back to Attachments",
            backButton: true,
            nextPageName: "Completion Info",
            previousPageName: "Attachments",
            requiredButton: true,
            mainHeader: "Part Replacement",
            subHeader: "",
            secondSubHeaderAndDate: false,
        },
        {
            currentPageName: "Completion Info",
            setPage: setPage,
            cancelButtonName: "Cancel",
            continueButtonName: "Continue to Cost Info",
            backButtonName: hasPartReplacement ? "Back to Part Replacement" : "Back to Attachments",
            backButton: true,
            nextPageName: "Cost Info",
            previousPageName: hasPartReplacement ? "Part Replacement" : "Attachments",
            mainHeader: "Completion Info",
            subHeader: "",
            secondSubHeaderAndDate: false,
            requiredButton: true,
        },
        {
            currentPageName: "Cost Info",
            setPage: setPage,
            cancelButtonName: "Cancel",
            continueButtonName: "Continue to Authorization",
            backButtonName: "Back to Completion Info",
            backButton: true,
            nextPageName: "Authorization & Summary",
            previousPageName: "Completion Info",
            requiredButton: true,
            mainHeader: "Cost Info",
            subHeader: "",
            secondSubHeaderAndDate: false,
        },
        // {
        //     currentPageName: "Attachments",
        //     setPage: setPage,
        //     cancelButtonName: "Cancel",
        //     continueButtonName: "Continue to Authorization",
        //     backButtonName: "Back to Cost Info",
        //     backButton: true,
        //     nextPageName: "Authorization & Summary",
        //     previousPageName: "Cost Info",
        //     requiredButton: true,
        //     mainHeader: "Attachments",
        //     subHeader: "",
        //     secondSubHeaderAndDate: false,
        // },
        {
            currentPageName: "Authorization & Summary",
            setPage: setPage,
            cancelButtonName: "Cancel",
            continueButtonName: "Authorize",
            backButtonName: "Back to Cost Info",
            backButton: true,
            nextPageName: "Authorization & Summary",
            previousPageName: "Cost Info",
            mainHeader: "Authorization & Summary",
            subHeader: "",
            secondSubHeaderAndDate: false,
            requiredButton: false,
        }
    ].filter(Boolean); // Filter out the 'Part Replacement' object if it's not needed

    const renderPageContent = () => {
        switch (page) {
            case "Basic Details":
                return (
                    <BasicDetails
                        page={page}
                        setPage={setPage}
                        buttonAttributes={buttonAttributes}
                    />
                );
            case "Assessments":
                return (
                    <Assessments
                        page={page}
                        setPage={setPage}
                        buttonAttributes={buttonAttributes}
                    />
                );

            case "Attachments":
                return (
                    <Attachments
                        page={page}
                        setPage={setPage}
                        buttonAttributes={buttonAttributes}
                    />
                );
                    
            case "Part Replacement":
                return (
                    <PartReplacement
                        page={page}
                        setPage={setPage}
                        buttonAttributes={buttonAttributes}
                    />
                );
            case "Completion Info":
                return (
                    <CompletionInfo
                        page={page}
                        setPage={setPage}
                        buttonAttributes={buttonAttributes}
                    />
                );
            case "Cost Info":
                return (
                    <CostInfo
                        page={page}
                        setPage={setPage}
                        buttonAttributes={buttonAttributes}
                    />
                );
            case "Authorization & Summary":
                return (
                    <SummaryAuthorization
                        page={page}
                        setPage={setPage}
                        buttonAttributes={buttonAttributes}
                        setAuthorizeTick={setAuthourizeTick}
                    />
                );
            default:
                return null;
        }
    };

    const renderMandatoryFields = () => {
        let mandatoryFieldsFind = [];

        switch (page) {
            case "Basic Details":
                mandatoryFieldsFind = mandatoryBasicDetails;
                break;
            case "Assessments":
                mandatoryFieldsFind = assessmentsMandatoryFields;
                break;
            case "Completion Info":
                mandatoryFieldsFind = completionInfoMandatoryFields;
                break;
            default:
                mandatoryFieldsFind = [];
        }

        // Check if mandatoryFieldsFind is undefined before mapping
        if (mandatoryFieldsFind === undefined) {
            return null;
        }

        return mandatoryFieldsFind?.map((field, index) => (
            <Grid
                key={index}
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    marginBottom: "5px",
                }}
            >
                {field.isVisible === true ?
                    <>
                        {field.valueFilled === false ? <HighlightOffRoundedIcon
                            color="disabled"
                            sx={{ fontSize: 16, marginRight: "5px" }}
                        /> :
                            <CheckCircleOutlineIcon
                                color="success"
                                sx={{ fontSize: 16, marginRight: "5px" }}
                            />}
                        <Typography
                            variant='labelSm'
                            color={'text.grey'}
                            component={'label'}
                            sx={{
                                fontSize: {
                                    xs: '1rem', // Small size for extra small screens
                                    sm: '0.875rem', // Slightly larger for small screens
                                    md: '1rem', // Default size for medium screens and up
                                },
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: {
                                    xs: '150px', // Maximum width for extra small screens
                                    sm: '200px', // Maximum width for small screens
                                    md: '250px', // Maximum width for medium screens
                                },
                            }}
                        >
                            {field.type}
                        </Typography>
                    </>
                    :
                    null
                }
            </Grid>
        ));
    };

    return (
        <>
            <PageTitle title={title} />
            <Box mt={{ xs: 1, sm: 2 }}>
                <Grid container sx={{ display: "flex" }} spacing={2}>
                    <Grid item xs={12} sm={3.4} md={2.2}>
                        <DefaultCard sx={{ height: "100%" }}>
                            <Box pb={{ xs: 1, sm: 5 }}>
                                <VerticalLinearStepper page={page} steps={updatedSteps} />
                                <Box>
                                    {page === "Attachments" ? null : page ===
                                        "Tc Others Details" ? null : (
                                        <>
                                            <Divider variant="middle" sx={{ marginBottom: "10%" }} />
                                            {page === "Basic Details" && (
                                                <Typography color='text.primary' mb={2} >
                                                    You can go to the next step once you complete these
                                                    following mandatory input fields
                                                </Typography>
                                            )}
                                            {page === "Assessments" && assessmentsMandatoryFields && (
                                                <Typography color='text.primary' mb={2} >
                                                    You can go to the next step once you complete these
                                                    following mandatory input fields
                                                </Typography>
                                            )}
                                            {page === "Completion Info" && completionInfoMandatoryFields && (
                                                <Typography color='text.primary' mb={2} >
                                                    You can go to the next step once you complete these
                                                    following mandatory input fields
                                                </Typography>
                                            )}
                                        </>
                                    )}
                                    {renderMandatoryFields()}
                                </Box>

                            </Box>
                        </DefaultCard>
                    </Grid>
                    <Grid item xs={12} sm={8.6} md={9.8}>
                        <DefaultCard sx={{ height: "100%" }}>
                            <DefaultCard sx={{ height: "100%" }}>
                                {renderPageContent()}
                            </DefaultCard>
                        </DefaultCard>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default WorkOrderStepper;
